import React from 'react';
import { Circle, Navigation2 } from 'lucide-react';

export const RecordingStatus = ({ 
  pointCount, 
  lastPoint, 
  currentGrade,
  currentLocation 
}) => {
  return (
    <div className="fixed top-20 right-4 bg-[#2A2B2E]/90 backdrop-blur-sm rounded-lg p-4 shadow-lg z-[100]">
      <div className="flex items-center gap-2 mb-3">
        <Circle className="w-4 h-4 text-red-500 animate-pulse" />
        <span className="text-white font-medium">Recording Profile</span>
      </div>

      <div className="space-y-2 text-sm">
        <div className="flex justify-between text-gray-400">
          <span>Points:</span>
          <span className="text-white">{pointCount}</span>
        </div>

        <div className="flex justify-between text-gray-400">
          <span>Distance:</span>
          <span className="text-white">
            {lastPoint ? `${(lastPoint.distance / 1000).toFixed(2)} km` : '0 km'}
          </span>
        </div>

        <div className="flex justify-between text-gray-400">
          <span>Current Elevation:</span>
          <span className="text-white">
            {currentLocation?.altitude ? 
              `${currentLocation.altitude.toFixed(1)}m` : 
              'N/A'
            }
          </span>
        </div>

        <div className="flex justify-between text-gray-400">
          <span>Current Grade:</span>
          <span className="text-white">
            {currentGrade ? `${currentGrade}%` : 'N/A'}
          </span>
        </div>

        {lastPoint && (
          <div className="flex justify-between text-gray-400">
            <span>Last Slope:</span>
            <span className="text-white">
              {calculateSlope(lastPoint, currentLocation)}%
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

const calculateSlope = (lastPoint, currentLocation) => {
  if (!lastPoint || !currentLocation?.altitude) return 'N/A';

  const elevationChange = currentLocation.altitude - lastPoint.elevation;
  const distance = Math.sqrt(
    Math.pow(currentLocation.lat - lastPoint.latitude, 2) +
    Math.pow(currentLocation.lng - lastPoint.longitude, 2)
  ) * 111319.9; // Convert to meters

  if (distance === 0) return '0.0';
  return ((elevationChange / distance) * 100).toFixed(1);
};